
import { useRegister } from '@platyplus/vue-hasura-backend-plus'
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Register',
  setup() {
    const router = useRouter()
    const email = ref('')
    const password = ref('')
    const { register, error } = useRegister(email, password)
    const registerUser = async () => {
      await register()
      if (!error.value) {
        router.push({ name: 'root' })
      }
    }
    return {
      email,
      password,
      registerUser,
      status,
      error
    }
  }
})
